import { ComponentFactoryResolver, ChangeDetectorRef } from '@angular/core';
import { DataEntityInputComponent } from './../../data-entity-input/data-entity-input.component';
import { Component, OnInit } from '@angular/core';
import { RichTextDataEntity } from 'src/app/models/data-entities/rich-text-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-rich-text-data-entity-input',
    templateUrl: './rich-text-data-entity-input.component.html',
    styleUrls: ['./rich-text-data-entity-input.component.css'],
    standalone: false
})
export class RichTextDataEntityInputComponent extends DataEntityInputComponent
  implements OnInit {
  public de: RichTextDataEntity;
public templateForPermitForm: boolean;
  constructor(public layoutService: LayoutService, componentFactoryResolver: ComponentFactoryResolver, ref: ChangeDetectorRef, context: WorkflowContextService) {
    super(layoutService, componentFactoryResolver, ref, context);

     layoutService.useNewLayout$.subscribe((useNewLayout) => { 
      this.templateForPermitForm = useNewLayout;
    });
  }

  ngOnInit() {
    this.de = this.entity as RichTextDataEntity;
  }
}
